<template>
  <div :class="{'op--modal-container':true, 'hide':!show}" @click="close">
    <div class="op--modal">
      <div class="op--modal-content brand-form" @click.stop>

        <div class="heading" id="addBrand">
          <span v-if="editID">Edit Brand</span>
          <span v-else>Add Brand</span>
        </div>

        <div class="error-box" v-show="!!errorReturn">{{ errorReturn }}</div>

        <div class="row row-padding">
          <div class="small-6 columns padding-R">
            <div class="data-field">
              <div class="label">Brand Name</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.brandName}" v-model="brandName" />
              <span class="error-msg">{{ error.brandName }}</span>
            </div>
          </div>

          <div class="small-6 columns padding-L">
            <div class="data-field">
              <div class="label">Phone</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.mobile}" v-model="mobile" />
              <span class="error-msg">{{ error.mobile }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="small-6 columns padding-R">
            <div class="data-field">
              <div class="label">Website</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.website}" v-model="website" />
              <span class="error-msg">{{ error.website }}</span>
            </div>
          </div>
          <div class="small-6 columns padding-L">
            <div class="data-field">
              <div class="label">Webform</div>
              <select v-model="webform" :class="{'has-error':!!error.webform}">
                <option v-for="webform in webforms" :value="webform.id">{{webform.name}}</option>
              </select>
              <span class="error-msg">{{ error.webform }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="small-12 columns">
            <div class="data-field">
              <div class="label">Street Address</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.street}" v-model="street" />
              <span class="error-msg">{{ error.street }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="small-4 columns padding-R">
            <div class="data-field">
              <div class="label">City</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.city}" v-model="city" />
              <span class="error-msg">{{ error.city }}</span>
            </div>
          </div>
          <div class="small-4 columns padding-L padding-R">
            <div class="data-field">
              <div class="label">State</div>
              <select v-model="state" :class="{'has-error':!!error.state}">
                <option v-for="state in states" :value="state.value">{{state.label}}</option>
              </select>
              <span class="error-msg">{{ error.state }}</span>
            </div>
          </div>
          <div class="small-4 columns">
            <div class="data-field padding-L">
              <div class="label">Zip</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.zip}" v-model="zip" />
              <span class="error-msg">{{ error.zip }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="small-6 columns padding-R full-field">
            <div class="data-field">
              <div class="label">FAQ</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.faq}" v-model="faq" />
              <span class="error-msg">{{ error.faq }}</span>
            </div>
          </div>
          <div class="small-6 columns padding-L full-field">
            <div class="data-field">
              <div class="label">Terms & Condition</div>
              <input type="text" :class="{'input':true, 'has-error':!!error.terms}" v-model="terms" />
              <span class="error-msg">{{ error.terms }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding" v-if="editID">
          <div class="small-6 columns padding-R full-field">
            <div class="data-field">
              <div class="label">Charter Booking</div>
              <select v-model="charterBooking">
                <option value="enabled">Enabled</option>
                <option value="disabled">Disabled</option>
              </select>
            </div>
          </div>
        </div>

        <div class="email-settings">
          <div class="sub-heading">Email Settings</div>

          <div class="row">
            <div class="small-4 columns padding-R full-field">
              <div class="data-field margin-B">
                <div class="label">Support Email</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.supportEmail}" v-model="supportEmail" />
                <span class="error-msg">{{ error.supportEmail }}</span>
              </div>
            </div>
            <div class="small-4 columns padding-R padding-L full-field">
              <div class="data-field">
                <div class="label">Send Email As</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.sendEmailAs}" v-model="sendEmailAs" />
                <span class="error-msg">{{ error.sendEmailAs }}</span>
              </div>
            </div>
            <div class="small-4 columns padding-L full-field">
              <div class="data-field">
                <div class="label">Email Highlight Color</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.emailColor}" @click="showEmailColor = true"
                  v-model="emailColor"/>
                <transition name="slide-down">
                  <div class="color-picker right" v-show="showEmailColor">
                    <photoshop-picker v-model="emailColors" @ok="selectColor('email')"></photoshop-picker>
                  </div>
                </transition>
                <span class="error-msg">{{ error.emailColor }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-12 columns">
              <div class="data-field margin-B">
                <div class="label">Email Logo <span class="secondary">(600x80px)</span></div>
                <div class="target-frame h80" @click="triggerUpload('emailLogo')">
                  <i class="fas fa-spinner fa-spin fa-5x" v-if="uploadLoading.emailLogo"></i>
                  <img :src="file.emailLogo" v-else-if="!!file.emailLogo" />
                  <i class="fas fa-image fa-5x" v-else="file.emailLogo"></i>
                </div>
                <span class="error-msg">{{ error.file.emailLogo }}</span>
                <input type="file" :class="{'input':true, 'has-error':!!error.brandName}" id="emailLogo" ref="emailLogo" v-show="false"
                  @change="uploadImg" accept="image/*" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-12 columns">
              <div class="data-field margin-B">
                <div class="label">Confirmation Email Contact Information</div>
                <textarea :class="{'has-error':!!error.confirmEmail}" v-model="confirmEmail"></textarea>
                <span class="error-msg">{{ error.confirmEmail }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-12 columns">
              <div class="data-field margin-B">
                <div class="label">App Download Banner <span class="secondary">(600x196px)</span></div>
                <div class="target-frame h196" @click="triggerUpload('appDownload')">
                  <i class="fas fa-spinner fa-spin fa-5x" v-if="uploadLoading.appDownload"></i>
                  <img :src="file.appDownload" v-else-if="!!file.appDownload" />
                  <i class="fas fa-image fa-5x" v-else="file.appDownload"></i>
                </div>
                <span class="error-msg">{{ error.file.appDownload }}</span>
                <input type="file" :class="{'input':true, 'has-error':!!error.brandName}" id="appDownload" ref="appDownload" v-show="false"
                  @change="uploadImg" accept="image/*" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-6 columns padding-R">
              <div class="data-field margin-B">
                <div class="label">iOS Download Button <span class="secondary">(190x60px)</span></div>
                <div class="target-frame h60" @click="triggerUpload('iosDownload')">
                  <i class="fas fa-spinner fa-spin fa-4x" v-if="uploadLoading.iosDownload"></i>
                  <img :src="file.iosDownload" v-else-if="!!file.iosDownload" />
                  <i class="fas fa-image fa-4x" v-else="file.iosDownload"></i>
                </div>
                <span class="error-msg">{{ error.file.iosDownload }}</span>
                <input type="file" :class="{'input':true, 'has-error':!!error.brandName}" id="iosDownload" ref="iosDownload" v-show="false"
                  @change="uploadImg" accept="image/*" />
              </div>
            </div>

            <div class="small-6 columns padding-L">
              <div class="data-field margin-B">
                <div class="label">Android Download Button <span class="secondary">(190x60px)</span></div>
                <div class="target-frame h60" @click="triggerUpload('androidDownload')">
                  <i class="fas fa-spinner fa-spin fa-4x" v-if="uploadLoading.androidDownload"></i>
                  <img :src="file.androidDownload" v-else-if="!!file.androidDownload" />
                  <i class="fas fa-image fa-4x" v-else="file.androidDownload"></i>
                </div>
                <span class="error-msg">{{ error.file.androidDownload }}</span>
                <input type="file" :class="{'input':true, 'has-error':!!error.brandName}" id="androidDownload" ref="androidDownload" v-show="false"
                  @change="uploadImg" accept="image/*" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-6 columns padding-R full-field">
              <div class="data-field">
                <div class="label">iOS Download Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.iosDownloadLink}" v-model="iosDownloadLink" />
                <span class="error-msg">{{ error.iosDownloadLink }}</span>
              </div>
            </div>
            <div class="small-6 columns padding-L full-field">
              <div class="data-field">
                <div class="label">Android Download Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.androidDownloadLink}" v-model="androidDownloadLink" />
                <span class="error-msg">{{ error.androidDownloadLink }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-6 columns end padding-R">
              <div class="data-field">
                <div class="label">Brand Color</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.brandColor}" @click="showBrandColor = true"
                  v-model="brandColor" />
                <transition name="slide-down">
                  <div class="color-picker left" v-show="showBrandColor">
                    <photoshop-picker v-model="brandColors" @ok="selectColor('brand')"></photoshop-picker>
                  </div>
                </transition>
                <span class="error-msg">{{ error.brandColor }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="social-links">
          <div class="sub-heading">Social Links</div>

          <div class="row">
            <div class="small-4 columns padding-R full-field">
              <div class="data-field margin-B">
                <div class="label">Facebook Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.facebookLink}" v-model="facebookLink" />
                <span class="error-msg">{{ error.facebookLink }}</span>
              </div>
            </div>
            <div class="small-4 columns padding-R padding-L full-field">
              <div class="data-field">
                <div class="label">Twitter Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.twitterLink}" v-model="twitterLink" />
                <span class="error-msg">{{ error.twitterLink }}</span>
              </div>
            </div>
            <div class="small-4 columns padding-L full-field">
              <div class="data-field">
                <div class="label">Text Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.textLink}" v-model="textLink" />
                <span class="error-msg">{{ error.textLink }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-4 columns padding-R full-field">
              <div class="data-field margin-B">
                <div class="label">Facebook App ID</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.facebookAppID}" v-model="facebookAppID" />
                <span class="error-msg">{{ error.facebookAppID }}</span>
              </div>
            </div>
            <div class="small-4 columns padding-R padding-L full-field">
              <div class="data-field">
                <div class="label">Share Wording</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.shareWording}" v-model="shareWording" />
                <span class="error-msg">{{ error.shareWording }}</span>
              </div>
            </div>
            <div class="small-4 columns padding-L full-field">
              <div class="data-field">
                <div class="label">About Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.aboutLink}" v-model="aboutLink" />
                <span class="error-msg">{{ error.aboutLink }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-4 columns end padding-R full-field">
              <div class="data-field margin-B">
                <div class="label">Email Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.emailLink}" v-model="emailLink" />
                <span class="error-msg">{{ error.emailLink }}</span>
              </div>
            </div>
            <div class="small-4 columns end padding-R padding-L full-field">
              <div class="data-field margin-B">
                <div class="label">Instagram Link</div>
                <input type="text" :class="{'input':true, 'has-error':!!error.instagramLink}" v-model="instagramLink" />
                <span class="error-msg">{{ error.instagramLink }}</span>
              </div>
            </div>
          </div>

          <div class="row isMobile">
            <div :class="{'button cta small error delete':true, 'disabled':submitLoading}" @click="showConfirm = true" v-if="editID">DELETE</div>
          </div>

        </div>

        <div class="fixed-footer">
          <div :class="{'button cta small error delete':true, 'disabled':submitLoading}" @click="showConfirm = true" v-if="editID">DELETE</div>
          <div :class="{'button cta small warning':true, 'disabled':submitLoading}" @click="close">CANCEL</div>
          <div :class="{'button cta small':true, 'disabled':submitLoading}" @click="submit">
            <span v-if="editID">Save</span>
            <span v-else>Add</span>
          </div>
        </div>

        <div :class="{'op--modal-container':true, 'hide':!showConfirm}" @click="closeConfirmation">
          <div class="op--modal">
            <div class="op--modal-content center">
              <div class="confirm-delete" @click.stop>
                <span>Are you sure you want to delete this brand?</span>

                <div :class="{'button cta warning':true, 'disabled': submitLoading}" @click="closeConfirmation">No</div>
                <div :class="{'button cta success':true, 'disabled': submitLoading}" @click="deleteBrand">YES</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import US from 'us'
import { Photoshop } from 'vue-color'
import ApiBrands from '@/modules/api/brands'
import services from '@/modules/api/services'

export default {
  name: 'brand-add',
  components: { 'photoshop-picker': Photoshop },
  data () {
    return {
      id: '',
      brandName: '',
      mobile: '',
      website: '',
      webform: 0,
      street: '',
      city: '',
      state: '',
      zip: '',
      faq: '',
      terms: '',
      charterBooking: 'disabled',
      supportEmail: '',
      sendEmailAs: '',
      emailColor: '',
      brandColor: '',
      emailColors: '',
      brandColors: '',
      showEmailColor: false,
      showBrandColor: false,
      file: {
        emailLogo: '',
        appDownload: '',
        iosDownload: '',
        androidDownload: '',
        shared: '',
        opoli: '',
        black: '',
        suv: '',
        shuttle: ''
      },
      uploadLoading: {
        emailLogo: false,
        appDownload: false,
        iosDownload: false,
        androidDownload: false,
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      confirmEmail: '',
      iosDownloadLink: '',
      androidDownloadLink: '',
      shared: '',
      opoli: '',
      black: '',
      suv: '',
      shuttle: '',
      facebookLink: '',
      twitterLink: '',
      textLink: '',
      facebookAppID: '',
      shareWording: '',
      aboutLink: '',
      emailLink: '',
      instagramLink: '',
      error: {
        brandName: '',
        mobile: '',
        website: '',
        webform: '',
        street: '',
        city: '',
        state: '',
        zip: '',
        faq: '',
        terms: '',
        supportEmail: '',
        sendEmailAs: '',
        emailColor: '',
        brandColor: '',
        emailColors: '',
        brandColors: '',
        file: {
          emailLogo: '',
          appDownload: '',
          iosDownload: '',
          androidDownload: '',
          shared: '',
          opoli: '',
          black: '',
          suv: '',
          shuttle: ''
        },
        confirmEmail: '',
        iosDownloadLink: '',
        androidDownloadLink: '',
        shared: '',
        opoli: '',
        black: '',
        suv: '',
        shuttle: '',
        facebookLink: '',
        twitterLink: '',
        textLink: '',
        facebookAppID: '',
        shareWording: '',
        aboutLink: '',
        emailLink: '',
        instagramLink: ''
      },
      errorReturn: '',
      showConfirm: false,
      submitLoading: false
    }
  },
  computed: {
    brandStore () { return this.$store.state.brands} ,
    show () { return this.brandStore.showBrandForm },
    webforms () { return this.brandStore.webform.list },
    states () {
      let states = []
      for (let key in US.states) {
        if (US.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: US.states[key].name
          })
        }
      }
      return states
    },
    editID () { return this.brandStore.editBrands.id },
  },
  methods: {
    selectColor (target) {
      if (!this[target + 'Colors']) { return }
      this[target + 'Color'] = this[target + 'Colors'].hex.substring(1, this[target + 'Colors'].hex.length)
      this.showEmailColor = false
      this.showBrandColor = false
    },
    triggerUpload (ref) {
      if (this.uploadLoading[ref]) { return }
      this.$refs[ref].click()
    },
    uploadImg (e) {
      if (!e.target.files.length) { return }

      let self = this
      let file = e.target.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.uploadLoading[e.target.id] = true

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.uploadLoading[e.target.id] = false
        console.log('success', res)
        if (!res.body.success) {
          // self.$store.commit('provider/showUploadError', true)
        } else {
          self.file[e.target.id] = res.body.data.url
        }
      }, function (res) {
        console.log('error', res)
        // self.$store.commit('provider/showUploadError', true)
      })
    },
    close () {
      this.$store.commit('brands/setShowBrandForm', false)
      if (this.editID) {
        this.$store.commit('brands/setEditBrands', {})
        this.clearForm()
      }
    },
    clearForm () {
      this.id = ''
      this.brandName = ''
      this.mobile = ''
      this.website = ''
      this.webform = ''
      this.street = ''
      this.city = ''
      this.state = ''
      this.zip = ''
      this.faq = ''
      this.terms = ''
      this.supportEmail = ''
      this.sendEmailAs = ''
      this.emailColor = ''
      this.brandColor = ''
      this.file.emailLogo = ''
      this.file.appDownload = ''
      this.file.iosDownload = ''
      this.file.androidDownload = ''
      this.file.shared = ''
      this.file.opoli = ''
      this.file.black = ''
      this.file.suv = ''
      this.file.shuttle = ''
      this.confirmEmail = ''
      this.iosDownloadLink = ''
      this.androidDownloadLink = ''
      this.shared = ''
      this.opoli = ''
      this.black = ''
      this.suv = ''
      this.shuttle = ''
      this.facebookLink = ''
      this.twitterLink = ''
      this.textLink = ''
      this.facebookAppID = ''
      this.shareWording = ''
      this.aboutLink = ''
      this.emailLink = ''
      this.instagramLink = ''
    },
    submit () {
      let self = this

      if (!self.validate()) { return }

      let editID = self.editID
      if (editID) {
        ApiBrands.updateBrand(self, self.compileBrandData(), function (res) {
          if (res.error) {
            self.errorReturn = res.error.message
            self.scrollToTop()
            return
          }
          self.updateService()
        })
      } else {
        ApiBrands.addBrand(self, self.compileBrandData(), function (res) {
          if (res.error) {
            self.errorReturn = res.error.message
            self.scrollToTop()
            return
          }

          self.id = res.id
          self.updateService()
        })
      }
    },
    updateService () {
      let self = this
      // ApiBrands.updateService(self, {
      //   id: self.id,
      //   services: [
      //     { id: CONFIG.serviceId.shared, name: self.shared, image: self.file.shared },
      //     { id: CONFIG.serviceId.opoli, name: self.opoli, image: self.file.opoli },
      //     { id: CONFIG.serviceId.black, name: self.black, image: self.file.black },
      //     { id: CONFIG.serviceId.suv, name: self.suv, image: self.file.suv },
      //     { id: CONFIG.serviceId.shuttle, name: self.shuttle, image: self.file.shuttle }
      //   ]
      // }, function (res) {
      //   if (res.error) {
      //     self.errorReturn = res.error.message
      //     self.scrollToTop()
      //     return
      //   }

      //   self.updateProps()
      // })
      self.$sdk.post('/charter/brands', {
        token: self.$store.state.session.sessionToken,
        brandId: self.editID,
        enabled: self.charterBooking === 'enabled'
      }, r => {
        self.updateProps()
      }, '')
    },
    updateProps () {
      let self = this
      ApiBrands.updateProps(self, self.compilePropsData(), function (res) {
        if (res.error) {
          self.errorReturn = res.error.message
          self.scrollToTop()
          return
        }

        location.reload()
      })
    },
    compileBrandData () {
      return {
        id: this.id,
        name: this.brandName,
        website: this.website,
        webformId: this.webform,
        brandColor: this.brandColor,
        appIOSDownloadLink: this.iosDownloadLink,
        appAndroidDownloadLink: this.androidDownloadLink,
        phoneNumber: this.mobile,
        supportEmail: this.supportEmail,
        emailLogoUrl: this.file.emailLogo,
        emailFAQ: this.faq,
        emailTC: this.terms,
        emailHighlightColor: this.emailColor,
        emailLink: this.emailLink,
        address: this.street,
        zipCode: this.zip,
        state: this.state,
        city: this.city,
        emailSendAs: this.sendEmailAs,
        googleTrackingId: this.sendEmailAs,
        linkToChat: this.sendEmailAs,
        confirmEmailContactInformation: this.confirmEmail
      }
    },
    compilePropsData () {
      return {
        id: this.id,
        props: {
          appDownloadBanner: this.file.appDownload,
          appIOSDownloadButton: this.file.iosDownload,
          appAndroidDownloadButton: this.file.androidDownload,
          facebookLink: this.facebookLink,
          facebookAppId: this.facebookAppID,
          emailLink: this.emailLink,
          instagramLink: this.instagramLink,
          twitterLink: this.twitterLink,
          shareWording: this.shareWording,
          textLink: this.textLink,
          aboutLink: this.aboutLink
        }
      }
    },
    validate () {
      let noError = true

      let fields = [
        'brandName', 'mobile', 'website', 'webform', 'street', 'city',
        'state', 'zip', 'faq', 'terms', 'supportEmail', 'sendEmailAs', 'emailColor',
        'brandColor', 'confirmEmail', 'iosDownloadLink', 'androidDownloadLink',
        'facebookLink', 'twitterLink', 'textLink', 'facebookAppID', 'shareWording',
        'aboutLink', 'emailLink', 'instagramLink'
      ]
      fields.forEach(field => {
        if (!this[field]) {
          this.error[field] = 'This field cannot be empty.'
          noError = false
        }
      })

      let files = [
        'emailLogo', 'appDownload', 'iosDownload', 'androidDownload'
      ]
      files.forEach(file => {
        if (!this.file[file]) {
          this.error.file[file] = 'This field cannot be empty.'
          noError = false
        }
      })

      return noError
    },
    scrollToTop () {
      let elmnt = document.getElementById('addBrand')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
    deleteBrand () {
      let self = this
      ApiBrands.deleteBrand(self, self.editID, function (res) {
        if (res.error) {
          self.errorReturn = res.error.message
          self.scrollToTop()
          return
        }

        location.reload()
      })
    },
    closeConfirmation () {
      if (this.submitLoading) { return true }
      this.showConfirm = false
    },
    serviceLabel (code) { return services.getServiceName(code) }
  },
  watch: {
    show: function (value) {
      let editData = this.$store.state.brands.editBrands
      if (Object.keys(editData).length > 0) {
        if (value) {
          this.id = editData.id
          this.brandName = editData.name
          this.mobile = editData.phoneNumber
          this.website = editData.website
          this.webform = editData.webformId
          this.street = editData.address
          this.city = editData.city
          this.state = editData.state
          this.zip = editData.zipCode
          this.faq = editData.emailFAQ
          this.terms = editData.emailTC
          this.supportEmail = editData.supportEmail
          this.sendEmailAs = editData.emailSendAs
          this.emailColor = editData.emailHighlightColor
          this.brandColor = editData.brandColor
          this.file.emailLogo = editData.emailLogoUrl
          this.file.appDownload = editData.appDownloadImg
          this.file.iosDownload = editData.iosDownloadImg
          this.file.androidDownload = editData.androidDownloadImg
          // this.file.shared = editData.sharedImg
          // this.file.opoli = editData.opoliImg
          // this.file.black = editData.blackImg
          // this.file.suv = editData.suvImg
          // this.file.shuttle = editData.shuttleImg
          this.confirmEmail = editData.confirmEmailContactInformation.replace(/(<([^>]+)>)/ig, '').trim()
          this.iosDownloadLink = editData.appIOSDownloadLink
          this.androidDownloadLink = editData.appAndroidDownloadLink
          // this.shared = editData.sharedLabel
          // this.opoli = editData.opoliLabel
          // this.black = editData.blackLabel
          // this.suv = editData.suvLabel
          // this.shuttle = editData.shuttleLabel
          this.facebookLink = editData.facebookLink
          this.twitterLink = editData.twitterLink
          this.textLink = editData.textLink
          this.facebookAppID = editData.fbAppID
          this.shareWording = editData.shareWording
          this.aboutLink = editData.aboutLink
          this.emailLink = editData.emailLink
          this.instagramLink = editData.instagramLink
          this.charterBooking = this.brandStore.charterEnabled.findIndex(x => x == this.editID) > -1 ? 'enabled' : 'disabled'
        } else {
          this.clearForm()
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content.center{
  display: table-cell;
  vertical-align: middle;
}

.brand-form{
  background-color: #fff;
  width: 900px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: relative;
}

.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.email-settings{
  margin-top: 20px;
  padding: 30px;
  background: #fafafa;
  border-top:1px solid #ddd;
  border-bottom:1px solid #ddd;
  &:last-child{
    /*
    padding-bottom: 50px;
    margin-bottom: 0;
    */
  }
}
.social-links{
  margin-bottom: 20px;
  padding: 30px;
  background: #fff;
}
.sub-heading{
  font-weight: 600;
  color: #0D79F2;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}
.clear{ clear:both; }

.data-field{
  position: relative;
  margin-bottom: 10px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
    &.underline{
      padding-bottom: 3px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
    }
    .secondary{
      color: #5390dc;
      display: inline-block;
      margin-left:3px;
    }
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  textarea{
    border: 1px solid #ddd;
    width: 100%;
    height: 150px;
    resize: none;
    padding: 10px;
    font-size: 13px;
    color: #555;
    outline: none;
    margin-top: 5px;

    &.has-error{ border-color: #f20d0d; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}
select{
  margin-top: 1px;
  border: 1px solid #ddd;
  padding: 10px;
  color: #333;
  height: 45px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}
.target-frame{
  width: 100%;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #f3f3f3;
  padding: 5px;
  box-shadow: 0 0 0 3px #fff inset;
  overflow: hidden;
  max-width: 100%;
  cursor: pointer;

  &.h60{ max-height: 70px; }
  &.h80{ max-height: 90px; }
  &.h196{ max-height: 206px; }
  &.h200{
    max-height: 210px;
    img{ max-height: 200px; }
  }
  i{ color: #ccc; }
}
.upload-btn{ margin-bottom: 15px; }
.color-picker{
  position: absolute;
  top: 100%;
  z-index: 3;
  transform-origin: top center;

  &.right{ right: 0; }
  &.left{ left: 0; }
}

.row{ max-width: 100%; }
.row-padding{ padding: 2px 30px; }
.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.margin-B{ margin-bottom: 20px; }

.fixed-footer{
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: 900px;
  background: #f3f3f3;
  border-top:1px solid #ccc;
  padding: 6px 20px;
  margin-left: -458px;
  text-align: right;

  .delete{
    float:left;
  }
  .button{
    min-width: 120px;
    margin: 0 5px;
  }
}

.error-box{
  margin:0 30px;
  border:1px solid #f34c31;
  color:#f34c31;
  padding: 5px;
  margin-bottom: 15px;
  font-size:14px;
  font-weight:600;
}

.confirm-delete{
  width: 400px;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  text-align: center;
  color:#444;
  font-weight:600;

  span{
    display: block;
    margin-bottom: 15px;
  }
  .button{
    min-width: 100px;
    margin:0 5px;
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.isMobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .isMobile {
    display: block;
    text-align: center;
    margin-top: 20px;

    .button {
      width: 50%;
    }
  }
  .brand-form {
    width: 100%;
  }

  .full-field {
    width: 100%;
    padding: 0;

    .margin-B {
      margin-bottom: 10px;
    }
  }

  .fixed-footer {
    left: 0;
    margin-left: 0;
    text-align: center;

    .delete {
      display: none;
    }
  }

  .social-links {
    padding-bottom: 100px;
  }

  .op--modal-container {
    display: block;
    &.hide {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Brands/BrandAdd.vue